import { render, staticRenderFns } from "./codingForm.vue?vue&type=template&id=2a3a560a&scoped=true&"
import script from "./codingForm.vue?vue&type=script&lang=js&"
export * from "./codingForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a3a560a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\code\\gongfeng\\CVSCRM_CODE\\scrm_manage_front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2a3a560a')) {
      api.createRecord('2a3a560a', component.options)
    } else {
      api.reload('2a3a560a', component.options)
    }
    module.hot.accept("./codingForm.vue?vue&type=template&id=2a3a560a&scoped=true&", function () {
      api.rerender('2a3a560a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/web/comm/dealerManage/codingForm.vue"
export default component.exports